"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function usePasswordViewToggle() {
    var _a = (0, react_1.useState)('password'), type = _a[0], setType = _a[1];
    var onPasswordViewToggle = function () {
        if (type === 'password') {
            setType('text');
        }
        else {
            setType('password');
        }
    };
    return {
        type: type,
        iconName: type === 'password' ? 'ff-icon-hide-password' : 'ff-icon-show-password',
        onPasswordViewToggle: onPasswordViewToggle,
    };
}
exports.default = usePasswordViewToggle;
